<template>
  <div class="vue-city-picker city-lawyer-select">
    <form autocomplete="off" class="vue-select-form">
      <div class="icon" v-if="icon" :class="icon" />
      <v-select
        :clearable="false"
        :dropdown-should-open="dropdownShouldOpen"
        :filterable="false"
        :model-value="selected"
        :options="options"
        :placeholder="placeholder"
        @search="debouncedOnSearch"
        @update:model-value="setSelected"
      />
    </form>
  </div>
</template>

<script>
import { useCitySelect } from 'Main/composables/useCitySelect';
import debounce from 'lodash-es/debounce';
import vSelect from 'vue-select';

export default {

  components: {
    vSelect,
  },

  data() {
    const { components } = theme_vars;

    return {
      iconName: this.icon,
      isLoading: false,
      options: this.getInitialOptions(),
      placeholder: this.label || components.findLavendla,
    };
  },

  methods: {

    debouncedOnSearch: debounce(function (searchText) {
      this.onSearch(searchText);
    }, 300),

    getAction() {
      switch (this.type) {
        case 'lawyers':
          return 'getLawyerPosts';
        case 'cities':
          return 'getCityPosts';
        case 'therapy':
          return 'getTherapyPosts';
        default:
          return 'getCityPosts';
      }
    },

    getInitialOptions() {
      return [
        {
          choice: null,
          label: 'loading ...',
        },
      ];
    },

    mapPosts({ href, title }) {
      return {
        choice: href,
        label: title,
      };
    },
    onSearch(searchText) {
      if (this.isLoading || !searchText || searchText.length < 3) {
        return;
      }

      this.isLoading = true;

      this.$store
        .dispatch(`cities/${this.getAction()}`, { search: searchText })
        .then((response) => {
          this.isLoading = false;
          this.options = response.map(this.mapPosts);
        });
    },
  },
  name: 'CityLawyerPostSelect',

  props: {
    icon: {
      default: '',
      type: String,
    },
    label: {
      default: '',
      type: String,
    },
    type: {
      default: '',
      type: String,
    },
  },

  setup() {
    const { selected, setSelected, dropdownShouldOpen, filterBy } =
      useCitySelect();
    return { dropdownShouldOpen, filterBy, selected, setSelected };
  },
};
</script>
